import { RefObject } from 'react';

import { BundlePurchaseItemList } from '../types/add-to-cart';

export enum ProductPreviewNavigation {
  CART = 'product_preview_dialog_cart',
  CART_CODI = 'product_preview_dialog_cart_codi',
  CART_REPLACEMENT_GOODS = 'product_preview_dialog_cart_replacement_goods',
  CART_TO_ORDERSHEET = 'product_preview_dialog_cart_to_ordersheet',
  BRIDGE_ZEXPRESS = 'product_preview_dialog_bridge_zexpress',
  ORDERSHEET = 'product_preview_dialog_ordersheet',
  ZIGZIN_SALE = 'product_preview_dialog_bridge_zigzinsale',
  COUPON_APPLY = 'product_preview_dialog_coupon_apply',
}

//todo 전시 도메인 컴포넌트 타입으로 위젯이나 common으로 이동 필요
export interface ProductPreviewScreenProps {
  catalog_product_id: string;
  funnel_type?: string;
  container_ref?: RefObject<HTMLDivElement>;
  navigation?: ProductPreviewNavigation;
  is_group_order_bridge_test?: boolean;
  onAddCart?: (bundle_purchase_item_list: BundlePurchaseItemList) => void;
  onAfterPhotoReviewClick?: () => void;
  ReviewListTabContent?: React.FC<ReviewListTabContentProps>;
}

interface PhotoReviewListInput {
  catalog_product_id: string;
  review_id: string;
  attachment_position: number;
}

//todo 전시 도메인 컴포넌트 타입으로 위젯이나 common으로 이동 필요
export interface ReviewListTabContentProps {
  isZigzagApp?: boolean;
  catalog_product_id: string;
  is_product_preview?: boolean;
  disabled_back_with_close?: boolean;
  path: {
    photo_review?: {
      gallery: (product_id: string) => string;
      detail?: ({ catalog_product_id, review_id, attachment_position }: PhotoReviewListInput) => string;
      list?: ({ catalog_product_id, review_id, attachment_position }: PhotoReviewListInput) => string;
    };
    review: {
      list: (product_id: string) => string;
      detail?: (review_id: string, product_id?: string, isReplyScroll?: boolean) => string;
      report?: (review_id: string) => string;
      best?: (product_id: string, review_id?: string) => string;
      reviewer_review_list?: (reviewer_id: string) => string;
    };
  };
  ubl?: {
    navigation?: string;
  };
}
